import {
  Component, Input, Output, EventEmitter,
  OnChanges, SimpleChanges, OnInit, OnDestroy,
} from "@angular/core";
import { CommonModule } from "@angular/common";
import { Subscription } from "rxjs";
import { FindingDetailsModalService, FindingDetailsModalData } from "src/app/services/performance-service/finding-details-modal.service";
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: "app-finding-details-modal",
  standalone: true,
  imports: [
    TranslateModule,CommonModule],
  templateUrl: "./finding-details-modal.component.html",
  styleUrls: ["./finding-details-modal.component.scss"],
})
export class FindingDetailsModalComponent implements OnChanges, OnInit, OnDestroy {
  @Input() isOpen = false;
  @Output() closeModal = new EventEmitter<void>();

  descExpanded = false;
  expandedActions = new Set<number>();

  toggleAction(index: number): void {
    if (this.expandedActions.has(index)) {
      this.expandedActions.delete(index);
    } else {
      this.expandedActions.add(index);
    }
  }

  data: FindingDetailsModalData | null = null;

  private dataSub?: Subscription;

  constructor(private findingDetailsModalService: FindingDetailsModalService) {}

  ngOnInit(): void {
    this.dataSub = this.findingDetailsModalService.modalData$.subscribe(d => {
      if (d) { this.data = d; this.descExpanded = false; this.expandedActions.clear(); }
    });
  }

  ngOnDestroy(): void {
    this.dataSub?.unsubscribe();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes["isOpen"]) {
      if (!this.isOpen) {
        this.descExpanded = false;
        this.expandedActions.clear();
      }
    }
  }


  close() { this.closeModal.emit(); }

  get descriptionText(): string {
    const desc = this.data?.description ?? "";
    if (!desc || this.descExpanded) return desc;
    const limit = 90;
    return desc.length > limit ? desc.slice(0, limit) : desc;
  }

  get isDescTruncated(): boolean {
    return !this.descExpanded && (this.data?.description?.length ?? 0) > 90;
  }

  statusClass(status: string): string {
    if (status === "overdue") return "fd-action-card__due--overdue";
    if (status === "closed")  return "fd-action-card__due--closed";
    return "fd-action-card__due--on-time";
  }

  actionCalendarIcon(action: any): string {
    if (action.status === "overdue") return "assets/performance/action-calendar-due.svg";
    return "assets/performance/action-calendar-done.svg";
  }

  actionDateClass(action: any): string {
    return action.status === "overdue" ? "red" : "green";
  }
}
